import type { BoardRole } from '../contract';

// These describe what the API sends and are defined once, in the API contract (src/contract).
export type {
    ArchivedTask, BoardMember, BoardRole, BoardStats, KioskPhoto, SeriesScope, Task as BoardTask, TaskSearchResult,
} from '../contract';

export const canEditBoard = (role?: BoardRole) => role === 'owner' || role === 'editor';

// Assignees can't edit a task, but they can toggle it complete/incomplete.
export const canToggleTaskCompletion = (role?: BoardRole) => canEditBoard(role) || role === 'assignee';

export type BoardTab = 'board' | 'week' | 'manage' | 'archive' | 'stats';

// Which tabs a role is allowed to see on a board.
export const canViewBoardTab = (role: BoardRole | undefined, tab: BoardTab, isKiosk?: boolean): boolean => {
    if (isKiosk && (tab === 'board' || tab === 'stats')) {
        return false; // kiosk accounts are locked to the kiosk display
    }
    if (tab === 'manage' || tab === 'archive') {
        return canEditBoard(role); // viewers/assignees can't invite or rename, so there's nothing for them to manage
    }
    return true;
};

export type BoardState = {
    id: string;
    title: string;
    sectionOrder: string[]; // ordered section IDs
    sectionsById: Record<string, SectionState>;
    viewerRole?: BoardRole;
    isKiosk?: boolean;
    kioskMessage?: string;
    kioskPhotoUrls?: string[];
    archiveAfterDays?: number; // completed tasks are archived this many days after completion; 0 = never
};


export type SectionState = {
    id: string;
    title: string;
    taskIds: string[]; // ordered section IDs
};
